//TBD - refactor this file to smaller components
// TBD - change the 1 page to a multi step form
// TBD - add more validations to the form fields based on dependencies on other fields

"use client";

import type React from "react";

import { useState, useContext, useEffect } from "react";
import { Header } from "@/components/header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
//import { Textarea } from "@/components/ui/textarea"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { EventsContext } from "../context/eventsContext";
import { appEvent } from "../sampleData/sampleEventsData";
import { useRouter } from "next/navigation";
import ReactGA from "react-ga4";

const eventTypes = ["Non Residential", "Residential", "Other"];

const eventDuration = ["First Half", "Second Half", "Full Day"];

const natureByEventType: Record<string, string[]> = {
  "Non Residential": ["Cocktail", "Gala dinner", "Off-sites"],
  Residential: ["Conference", "Launches", "Workshops", "Seminars", "Training"],
  Other: ["Other"],
};

// TBD - these could go into the DB
const seatingStyle = ["Round", "Theater", "Classroom Type"];

const celebration = ["DJ", "AV", "Live Band"];

export default function EventRequestPage() {
  const router = useRouter();

  const { events, setEvents } = useContext(EventsContext);

  const [formData, setFormData] = useState<appEvent>({
    // 1. Event Information
    id: events.length + 1,
    name: "",
    type: "",
    nature: "",
    status: "requested",
    startDate: new Date(),
    endDate: new Date(),
    venueid: "",
    participants: 0,
    budget: 0,
    description: "",

    isEventDateFlexible: true,
    location: "",

    // 2. Requester Details
    requesterName: "",
    mobileNum: "",
    emailId: "",
    department: "",
    costCenter: "",
    bizEntity: "",

    // 3. Non-residential Events
    // are these 2 field redundant as they already exist in event information?
    eventTiming: "",
    eventDuration: "", // First half / Second Half / Full Day

    // 4. Event Requirements
    ohpProjector: false, // yes / No
    seatingStyle: "", // Round / Theatre / classroom
    flipChart: false,
    breakOutRooms: false,
    celebration: "", // DJ / Liveband / AV
    giftsToParticipants: "",
    othersEventRequirements: "",

    // 5. Snack & Meal
    mornCoffeeBreakTiming: "10:30 AM",
    eveTeaBreakTiming: "04:30 PM",
    numOfVegMeals: 0,
    numOfNonVegMeals: 0,
    isDinnerRequired: false,
    othersSnacknMeals: "",

    // 6. Budgets
    eventBudget: 0,
    airBudget: 0,
    stayBudget: 0,
    railRoadBudget: 0,
    avDjBudget: 0,
    giftBudget: 0,
    priorNightSetupBudget: 0,

    // 7. Residential Events
    numSingleRooms: 0,
    numDoubleRooms: 0,
    groundTransportReqd: false,
    numVipRooms: 0,
  });

  const selectedNatureOptions = natureByEventType[formData.type] ?? [];

  //const { setEvents } = useContext(EventsProvider as React.Context<EventsContextType>);

  const [errors, setErrors] = useState<Record<string, string>>({});

  /*const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === "participants" || name === "budget" ? Number(value) : value,
    }));
  };*/

  useEffect(() => {
    //console.log("Events after update:", events);
  }, [events]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Basic validation
    const newErrors: Record<string, string> = {};

    if (!formData.name.trim()) {
      newErrors.name = "Event name is required";
    }
    if (!formData.type) {
      newErrors.type = "Event type is required";
    }
    if (!formData.nature) {
      newErrors.nature = "Nature of Event is required";
    }
    if (!formData.budget || formData.budget <= 0) {
      newErrors.budget = "Estimated budget is required";
    }
    if (!formData.participants || formData.participants <= 0) {
      newErrors.participants = "Number of Attendees is required";
    }
    if (!formData.startDate) {
      newErrors.startDate = "Start date is required";
    }
    if (!formData.endDate) {
      newErrors.endDate = "End date is required";
    }
    if (
      formData.startDate &&
      formData.endDate &&
      formData.endDate < formData.startDate
    ) {
      newErrors.endDate = "End date cannot be before start date";
    }
    if (!formData.isEventDateFlexible) {
      newErrors.isEventDateFlexible = "Is Event date flexible is required";
    }
    if (!formData.location) {
      newErrors.location = "Event Location is required";
    }
    const mobileDigits = formData.mobileNum.replace(/\D/g, "");
    if (!formData.mobileNum.trim()) {
      newErrors.mobileNum = "Mobile number is required";
    } else if (mobileDigits.length !== 10) {
      newErrors.mobileNum = "Enter a valid mobile number";
    }
    if (!formData.emailId.trim()) {
      newErrors.emailId = "Email address is required";
    } else {
      const emailParts = formData.emailId.split("@");
      const domain = emailParts[1] ?? "";
      if (
        emailParts.length !== 2 ||
        !emailParts[0] ||
        !domain ||
        !domain.includes(".") ||
        formData.emailId.includes(" ")
      ) {
        newErrors.emailId = "Enter a valid email address";
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Handle form submission
      console.log("Form submitted:", formData);
      // TBD add code here to write the data to DB or temporarily inmem
      setEvents((events) => [...events, formData]);

      ReactGA.event({
        category: "User",
        action: "Clicked a button",
        label: "Submitted Event Request Form",
      }); //GA event tracking

      router.push("/events");
    }
  };

  const handleReset = () => {
    setFormData({
      id: events.length + 1,
      venueid: "",

      // 1. Event information
      name: "",
      type: "",
      nature: "",
      status: "requested",
      budget: 0,
      participants: 0,
      startDate: new Date("2000-01-01"),
      endDate: new Date("2000-01-01"),
      location: "",
      isEventDateFlexible: false,
      description: "",

      // 2. Requester Details
      requesterName: "",
      mobileNum: "",
      emailId: "",
      department: "",
      costCenter: "",
      bizEntity: "",

      // 3. Non-residential Events
      eventTiming: "",
      eventDuration: "", // First half / Second half / full day (9 am - 5 pm)

      // 4. Event Requirements
      ohpProjector: false, // yes / No
      seatingStyle: "", // Round / Theatre / classroom
      flipChart: false,
      breakOutRooms: false,
      celebration: "", // DJ / Liveband / AV
      giftsToParticipants: "",
      othersEventRequirements: "",

      // 5. Snack & Meal
      mornCoffeeBreakTiming: "",
      eveTeaBreakTiming: "",
      numOfVegMeals: 0,
      numOfNonVegMeals: 0,
      isDinnerRequired: false,
      othersSnacknMeals: "",

      // 6. Budgets
      eventBudget: 0,
      airBudget: 0,
      stayBudget: 0,
      railRoadBudget: 0,
      avDjBudget: 0,
      giftBudget: 0,
      priorNightSetupBudget: 0,

      // 7. Residential Events
      numSingleRooms: 0,
      numDoubleRooms: 0,
      groundTransportReqd: false,
      numVipRooms: 0,
    });
    setErrors({});
  };

  return (
    <>
      <Header
        title="Corporate Event Request form"
        subtitle="Create a new event request"
        showNewEventButton={false}
      />

      {/* removed this code due to fix double scroll bar issue */}
      <div className="flex-1 overflow-auto p-6">
        <form onSubmit={handleSubmit} className="flex flex-col space-y-6">
          <Card className="order-1">
            <CardHeader>
              <CardTitle>Event Information</CardTitle>
            </CardHeader>

            <CardContent>
              <div className="grid grid-cols-4 md:grid-cols-4 gap-8">
                <div className="space-y-4 col-span-2">
                  <Label htmlFor="eventName">
                    Name of the Event{" "}
                    <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="eventName"
                    placeholder="Name of the Event"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    className={cn(errors.name && "border-destructive")}
                  />
                  {errors.eventName && (
                    <p className="text-sm text-destructive">
                      {errors.eventName}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="eventType">
                    Event Type <span className="text-destructive">*</span>
                  </Label>

                  <Select
                    value={formData.type}
                    onValueChange={(value) =>
                      setFormData({ ...formData, type: value, nature: "" })
                    }
                  >
                    <SelectTrigger
                      className={cn(errors.type && "border-destructive")}
                    >
                      <SelectValue placeholder="Select event type" />
                    </SelectTrigger>

                    <SelectContent>
                      {eventTypes.map((type) => (
                        <SelectItem key={type} value={type}>
                          {type}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {errors.eventType && (
                    <p className="text-sm text-destructive">
                      {errors.eventType}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="eventNature">
                    Nature of Event <span className="text-destructive">*</span>
                  </Label>

                  <Select
                    value={formData.nature}
                    onValueChange={(value) =>
                      setFormData({ ...formData, nature: value })
                    }
                  >
                    <SelectTrigger
                      className={cn(errors.nature && "border-destructive")}
                    >
                      <SelectValue placeholder="Select nature of the event" />
                    </SelectTrigger>

                    <SelectContent>
                      {selectedNatureOptions.map((type) => (
                        <SelectItem key={type} value={type}>
                          {type}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>

                  {errors.eventNature && (
                    <p className="text-sm text-destructive">
                      {errors.eventNature}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="budget">
                    Estimated Budget <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="budget"
                    placeholder="Budget amount (INR)"
                    value={formData.budget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        budget: Number(e.target.value),
                      })
                    }
                    className={cn(errors.budget && "border-destructive")}
                  />
                  {errors.budget && (
                    <p className="text-sm text-destructive">{errors.budget}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="numOfAttendees">
                    No. of Attendees <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="numOfAttendees"
                    type="number"
                    placeholder="Number of Attendees"
                    value={formData.participants}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        participants: Number(e.target.value),
                      })
                    }
                    className={cn(errors.participants && "border-destructive")}
                  />
                  {errors.participants && (
                    <p className="text-sm text-destructive">
                      {errors.participants}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label>
                    Start Date <span className="text-destructive">*</span>
                  </Label>

                  <Popover>
                    <PopoverTrigger asChild>
                      <Button
                        variant="outline"
                        className={cn(
                          "w-full justify-start text-left font-normal",
                          !formData.startDate &&
                            "text-foreground text-slate-400",
                          errors.startDate && "border-destructive",
                        )}
                      >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {formData.startDate
                          ? format(formData.startDate, "dd-MM-yyyy")
                          : "dd-mm-yyyy"}
                      </Button>
                    </PopoverTrigger>

                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={formData.startDate}
                        onSelect={(date) =>
                          setFormData({ ...formData, startDate: date })
                        }
                        initialFocus
                      />
                    </PopoverContent>
                  </Popover>

                  {errors.startDate && (
                    <p className="text-sm text-destructive">
                      {errors.startDate}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label>
                    End Date <span className="text-destructive">*</span>
                  </Label>

                  <Popover>
                    <PopoverTrigger asChild>
                      <Button
                        variant="outline"
                        className={cn(
                          "w-full justify-start text-left font-normal",
                          !formData.endDate && "text-foreground text-slate-400",
                          errors.endDate && "border-destructive",
                        )}
                      >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {formData.endDate
                          ? format(formData.endDate, "dd-MM-yyyy")
                          : "dd-mm-yyyy"}
                      </Button>
                    </PopoverTrigger>

                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={formData.endDate}
                        disabled={
                          formData.startDate
                            ? { before: formData.startDate }
                            : undefined
                        }
                        onSelect={(date) =>
                          setFormData({ ...formData, endDate: date })
                        }
                        initialFocus
                      />
                    </PopoverContent>
                  </Popover>
                  {errors.endDate && (
                    <p className="text-sm text-destructive">{errors.endDate}</p>
                  )}
                </div>

                <div className="space-y-4 col-span-2">
                  <Label
                    htmlFor="isEventDateFlexible"
                    className="cursor-pointer"
                  >
                    <input
                      id="isEventDateFlexible"
                      type="checkbox"
                      checked={formData.isEventDateFlexible}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          isEventDateFlexible: e.target.checked,
                        })
                      }
                      className="h-4 w-4 rounded border-input accent-primary"
                    />
                    <span>
                      Is Event Dates Flexible?{" "}
                      <span className="text-destructive">*</span>
                    </span>
                  </Label>
                </div>

                <div className="space-y-4 col-span-2">
                  <Label htmlFor="eventLocation">
                    Location of the Event{" "}
                    <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="eventLocation"
                    placeholder="Location of the Event"
                    value={formData.location}
                    onChange={(e) =>
                      setFormData({ ...formData, location: e.target.value })
                    }
                    className={cn(errors.location && "border-destructive")}
                  />
                  {errors.location && (
                    <p className="text-sm text-destructive">
                      {errors.location}
                    </p>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="order-6">
            <CardHeader>
              <CardTitle>Requester Details</CardTitle>
            </CardHeader>

            <CardContent>
              <div className="grid grid-cols-3 md:grid-cols-3 gap-8">
                <div className="space-y-2">
                  <Label htmlFor="requesterName">
                    Requester&apos;s Name{" "}
                    <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="requesterName"
                    placeholder="Enter Requester's name"
                    value={formData.requesterName}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        requesterName: e.target.value,
                      })
                    }
                    className={cn(errors.requesterName && "border-destructive")}
                  />
                  {errors.requesterName && (
                    <p className="text-sm text-destructive">
                      {errors.requesterName}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="mobile">
                    Mobile <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="mobile"
                    type="tel"
                    placeholder="Enter Requester's Mobile Num"
                    value={formData.mobileNum}
                    onChange={(e) =>
                      setFormData({ ...formData, mobileNum: e.target.value })
                    }
                    className={cn(errors.mobileNum && "border-destructive")}
                  />

                  {errors.mobileNum && (
                    <p className="text-sm text-destructive">
                      {errors.mobileNum}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="emailId">
                    Email <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="emailId"
                    type="email"
                    placeholder="Enter Requester's email"
                    value={formData.emailId}
                    onChange={(e) =>
                      setFormData({ ...formData, emailId: e.target.value })
                    }
                    className={cn(errors.emailId && "border-destructive")}
                  />
                  {errors.emailId && (
                    <p className="text-sm text-destructive">{errors.emailId}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="Department">
                    Department <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="Department"
                    placeholder="Enter Department"
                    value={formData.department}
                    onChange={(e) =>
                      setFormData({ ...formData, department: e.target.value })
                    }
                    className={cn(errors.department && "border-destructive")}
                  />
                  {errors.department && (
                    <p className="text-sm text-destructive">
                      {errors.department}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="costCenter">
                    Cost Center <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="costCenter"
                    placeholder="Enter Cost Center"
                    value={formData.costCenter}
                    onChange={(e) =>
                      setFormData({ ...formData, costCenter: e.target.value })
                    }
                    className={cn(errors.costCenter && "border-destructive")}
                  />
                  {errors.costCenter && (
                    <p className="text-sm text-destructive">
                      {errors.costCenter}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="BusinessEntity">
                    Business Entity <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="BusinessEntity"
                    placeholder="Enter Business Entity"
                    value={formData.bizEntity}
                    onChange={(e) =>
                      setFormData({ ...formData, bizEntity: e.target.value })
                    }
                    className={cn(errors.bizEntity && "border-destructive")}
                  />
                  {errors.bizEntity && (
                    <p className="text-sm text-destructive">
                      {errors.bizEntity}
                    </p>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          {formData.type === "Residential" && (
            <Card className="order-2">
              <CardHeader>
                <CardTitle>Residential Events</CardTitle>
              </CardHeader>

              <CardContent>
                <div className="grid grid-cols-4 md:grid-cols-4 gap-4">
                  <div className="space-y-2">
                    <Label htmlFor="numSingleRooms">
                      No. of Single Occupancy Rooms{" "}
                      <span className="text-destructive"></span>
                    </Label>

                    <Input
                      id="numSingleRooms"
                      placeholder="Enter No. of Single Rooms"
                      value={formData.numSingleRooms}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          numSingleRooms: Number(e.target.value),
                        })
                      }
                      className={cn(
                        errors.numSingleRooms && "border-destructive",
                      )}
                    />
                    {errors.numSingleRooms && (
                      <p className="text-sm text-destructive">
                        {errors.numSingleRooms}
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="numDoubleRooms">
                      No. of Double Occupancy Rooms{" "}
                      <span className="text-destructive"></span>
                    </Label>

                    <Input
                      id="numDoubleRooms"
                      placeholder="Enter No. of Double Rooms"
                      value={formData.numDoubleRooms}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          numDoubleRooms: Number(e.target.value),
                        })
                      }
                      className={cn(
                        errors.numDoubleRooms && "border-destructive",
                      )}
                    />
                    {errors.numDoubleRooms && (
                      <p className="text-sm text-destructive">
                        {errors.numDoubleRooms}
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="numVipRooms">
                      No. of VIP Rooms{" "}
                      <span className="text-destructive"></span>
                    </Label>

                    <Input
                      id="numVipRooms"
                      placeholder="Enter No. of VIP Rooms"
                      value={formData.numVipRooms}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          numVipRooms: Number(e.target.value),
                        })
                      }
                      className={cn(errors.numVipRooms && "border-destructive")}
                    />
                    {errors.numVipRooms && (
                      <p className="text-sm text-destructive">
                        {errors.numVipRooms}
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <Label
                      htmlFor="groundTransportReqd"
                      className="cursor-pointer"
                    >
                      <input
                        id="groundTransportReqd"
                        type="checkbox"
                        checked={formData.groundTransportReqd}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            groundTransportReqd: e.target.checked,
                          })
                        }
                        className="h-4 w-4 rounded border-input accent-primary"
                      />{" "}
                      Is Ground Transport required?
                    </Label>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}

          {formData.type === "Non Residential" && (
            <Card className="order-2">
              <CardHeader>
                <CardTitle>Non-Residential Events</CardTitle>
              </CardHeader>

              <CardContent>
                <div className="grid grid-cols-4 md:grid-cols-4 gap-8">
                  <div className="space-y-2">
                    <Label htmlFor="EventTiming">
                      Event Timing <span className="text-destructive"></span>
                    </Label>

                    <Input
                      id="EventTiming"
                      placeholder="Enter Event Timing"
                      value={formData.eventTiming}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          eventTiming: e.target.value,
                        })
                      }
                      className={cn(errors.eventTiming && "border-destructive")}
                    />
                    {errors.eventTiming && (
                      <p className="text-sm text-destructive">
                        {errors.eventTiming}
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="eventDuration">
                      Event Duration <span className="text-destructive"></span>
                    </Label>

                    <Select
                      value={formData.eventDuration}
                      onValueChange={(value) =>
                        setFormData({
                          ...formData,
                          eventDuration: value as typeof formData.eventDuration,
                        })
                      }
                    >
                      <SelectTrigger
                        className={cn(
                          errors.eventDuration && "border-destructive",
                        )}
                      >
                        <SelectValue placeholder="Select event duration" />
                      </SelectTrigger>

                      <SelectContent>
                        {eventDuration.map((type) => (
                          <SelectItem key={type} value={type}>
                            {type}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    {errors.eventDuration && (
                      <p className="text-sm text-destructive">
                        {errors.eventDuration}
                      </p>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          )}

          <Card className="order-3">
            <CardHeader>
              <CardTitle>Events Requirments</CardTitle>
            </CardHeader>

            <CardContent>
              <div className="grid grid-cols-4 md:grid-cols-4 gap-8">
                <div className="space-y-2">
                  <Label htmlFor="ohpProjector" className="cursor-pointer">
                    <input
                      id="ohpProjector"
                      type="checkbox"
                      checked={formData.ohpProjector}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          ohpProjector: e.target.checked,
                        })
                      }
                      className="h-4 w-4 rounded border-input accent-primary"
                    />{" "}
                    OHP Projector <span className="text-destructive"></span>
                  </Label>
                  {errors.ohpProjector && (
                    <p className="text-sm text-destructive">
                      {errors.ohpProjector}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="seatingStyle">
                    Seating Style <span className="text-destructive"></span>
                  </Label>

                  <Select
                    value={formData.seatingStyle}
                    onValueChange={(value) =>
                      setFormData({
                        ...formData,
                        seatingStyle: value as
                          | ""
                          | "Round"
                          | "Theatre"
                          | "Classroom",
                      })
                    }
                  >
                    <SelectTrigger
                      className={cn(
                        errors.seatingStyle && "border-destructive",
                      )}
                    >
                      <SelectValue placeholder="Select Seating style" />
                    </SelectTrigger>

                    <SelectContent>
                      {seatingStyle.map((type) => (
                        <SelectItem key={type} value={type}>
                          {type}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {errors.seatingStyle && (
                    <p className="text-sm text-destructive">
                      {errors.seatingStyle}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="flipChart" className="cursor-pointer">
                    <input
                      id="flipChart"
                      type="checkbox"
                      checked={formData.flipChart}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          flipChart: e.target.checked,
                        })
                      }
                      className="h-4 w-4 rounded border-input accent-primary"
                    />{" "}
                    Flip Chart<span className="text-destructive"></span>
                  </Label>
                  {errors.flipChart && (
                    <p className="text-sm text-destructive">
                      {errors.flipChart}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="breakOutRooms" className="cursor-pointer">
                    <input
                      id="breakOutRooms"
                      type="checkbox"
                      checked={formData.breakOutRooms}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          breakOutRooms: e.target.checked,
                        })
                      }
                      className="h-4 w-4 rounded border-input accent-primary"
                    />{" "}
                    Breakout Rooms <span className="text-destructive"></span>
                  </Label>
                  {errors.breakOutRooms && (
                    <p className="text-sm text-destructive">
                      {errors.breakOutRooms}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="eventDuration">
                    Celebration <span className="text-destructive"></span>
                  </Label>

                  <Select
                    value={formData.celebration}
                    onValueChange={(value) =>
                      setFormData({
                        ...formData,
                        celebration: value as "" | "DJ" | "Liveband" | "AV",
                      })
                    }
                  >
                    <SelectTrigger
                      className={cn(errors.celebration && "border-destructive")}
                    >
                      <SelectValue placeholder="Select celebration" />
                    </SelectTrigger>

                    <SelectContent>
                      {celebration.map((type) => (
                        <SelectItem key={type} value={type}>
                          {type}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {errors.celebration && (
                    <p className="text-sm text-destructive">
                      {errors.celebration}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="giftsToParticipants">
                    Gift to Participants{" "}
                    <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="giftsToParticipants"
                    placeholder="Enter Gifts to participants"
                    value={formData.giftsToParticipants}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        giftsToParticipants: e.target.value,
                      })
                    }
                    className={cn(
                      errors.giftsToParticipants && "border-destructive",
                    )}
                  />
                  {errors.giftsToParticipants && (
                    <p className="text-sm text-destructive">
                      {errors.giftsToParticipants}
                    </p>
                  )}
                </div>

                <div className="space-y-2 span-3">
                  <Label htmlFor="othersEventRequirements">
                    Others <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="othersEventRequirements"
                    placeholder="Enter Others"
                    value={formData.othersEventRequirements}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        othersEventRequirements: e.target.value,
                      })
                    }
                    className={cn(
                      errors.othersEventRequirements && "border-destructive",
                    )}
                  />
                  {errors.othersEventRequirements && (
                    <p className="text-sm text-destructive">
                      {errors.othersEventRequirements}
                    </p>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="order-4">
            <CardHeader>
              <CardTitle>Snack & Meal</CardTitle>
            </CardHeader>

            <CardContent>
              <div className="grid grid-cols-3 md:grid-cols-3 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="numOfVegMeals">
                    Number of Veg meals{" "}
                    <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="numOfVegMeals"
                    placeholder="Enter Number of Veg meals"
                    value={formData.numOfVegMeals}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        numOfVegMeals: Number(e.target.value),
                      })
                    }
                    className={cn(errors.numOfVegMeals && "border-destructive")}
                  />
                  {errors.numOfVegMeals && (
                    <p className="text-sm text-destructive">
                      {errors.numOfVegMeals}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="numOfNonVegMeals">
                    Number of Non Veg meals{" "}
                    <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="numOfNonVegMeals"
                    placeholder="Enter number of Non Veg Meals"
                    value={formData.numOfNonVegMeals}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        numOfNonVegMeals: Number(e.target.value),
                      })
                    }
                    className={cn(
                      errors.numOfNonVegMeals && "border-destructive",
                    )}
                  />
                  {errors.numOfNonVegMeals && (
                    <p className="text-sm text-destructive">
                      {errors.numOfNonVegMeals}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="mornCoffeeBreakTiming">
                    Timing for Morning Coffee{" "}
                    <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="mornCoffeeBreakTiming"
                    placeholder="Enter timing for morning coffee"
                    value={formData.mornCoffeeBreakTiming}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mornCoffeeBreakTiming: e.target.value,
                      })
                    }
                    className={cn(
                      errors.mornCoffeeBreakTiming && "border-destructive",
                    )}
                  />
                  {errors.mornCoffeeBreakTiming && (
                    <p className="text-sm text-destructive">
                      {errors.mornCoffeeBreakTiming}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="eveTeaBreakTiming">
                    Timing for Evening Tea{" "}
                    <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="eveTeaBreakTiming"
                    placeholder="Enter timing for Evening tea"
                    value={formData.eveTeaBreakTiming}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        eveTeaBreakTiming: e.target.value,
                      })
                    }
                    className={cn(
                      errors.eveTeaBreakTiming && "border-destructive",
                    )}
                  />
                  {errors.eveTeaBreakTiming && (
                    <p className="text-sm text-destructive">
                      {errors.eveTeaBreakTiming}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="isDinnerRequired" className="cursor-pointer">
                    <input
                      id="isDinnerRequired"
                      type="checkbox"
                      checked={formData.isDinnerRequired}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          isDinnerRequired: e.target.checked,
                        })
                      }
                      className="h-4 w-4 rounded border-input accent-primary"
                    />{" "}
                    Is dinner required?
                  </Label>
                </div>

                <div className="space-y-2">
                  <Label htmlFor="eveTeaBreakTiming">
                    Others <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="eveTeaBreakTiming"
                    placeholder="Enter Others snack & meal"
                    value={formData.eveTeaBreakTiming}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        eveTeaBreakTiming: e.target.value,
                      })
                    }
                    className={cn(
                      errors.eveTeaBreakTiming && "border-destructive",
                    )}
                  />
                  {errors.eveTeaBreakTiming && (
                    <p className="text-sm text-destructive">
                      {errors.eveTeaBreakTiming}
                    </p>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="order-5">
            <CardHeader>
              <CardTitle>Budgets</CardTitle>
            </CardHeader>

            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="eventBudget">
                    Event Budget <span className="text-destructive">*</span>
                  </Label>

                  <Input
                    id="eventBudget"
                    placeholder="Enter Event Budget"
                    value={formData.eventBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        eventBudget: Number(e.target.value),
                      })
                    }
                    className={cn(errors.eventBudget && "border-destructive")}
                  />
                  {errors.eventBudget && (
                    <p className="text-sm text-destructive">
                      {errors.eventBudget}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="airBudget">
                    Air Budget <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="airBudget"
                    placeholder="Enter Air Budget"
                    value={formData.airBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        airBudget: Number(e.target.value),
                      })
                    }
                    className={cn(errors.airBudget && "border-destructive")}
                  />
                  {errors.airBudget && (
                    <p className="text-sm text-destructive">
                      {errors.airBudget}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="stayBudget">
                    Stay Budget <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="stayBudget"
                    placeholder="Enter Stay Budget"
                    value={formData.stayBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stayBudget: Number(e.target.value),
                      })
                    }
                    className={cn(errors.stayBudget && "border-destructive")}
                  />
                  {errors.stayBudget && (
                    <p className="text-sm text-destructive">
                      {errors.stayBudget}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="airBudget">
                    Rail / Road Budget{" "}
                    <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="railRoadBudget"
                    placeholder="Enter Rail / Road Budget"
                    value={formData.railRoadBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        railRoadBudget: Number(e.target.value),
                      })
                    }
                    className={cn(
                      errors.railRoadBudget && "border-destructive",
                    )}
                  />
                  {errors.railRoadBudget && (
                    <p className="text-sm text-destructive">
                      {errors.railRoadBudget}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="avDjBudget">
                    AV / DJ Budget <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="avDjBudget"
                    placeholder="Enter AV / DJ Budget"
                    value={formData.avDjBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        avDjBudget: Number(e.target.value),
                      })
                    }
                    className={cn(errors.avDjBudget && "border-destructive")}
                  />
                  {errors.avDjBudget && (
                    <p className="text-sm text-destructive">
                      {errors.avDjBudget}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="giftBudget">
                    Gift Budget <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="giftBudget"
                    placeholder="Enter Gift Budget"
                    value={formData.giftBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        giftBudget: Number(e.target.value),
                      })
                    }
                    className={cn(errors.giftBudget && "border-destructive")}
                  />
                  {errors.giftBudget && (
                    <p className="text-sm text-destructive">
                      {errors.stayBudget}
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="priorNightSetupBudget">
                    Prior Night Setup Budget{" "}
                    <span className="text-destructive"></span>
                  </Label>

                  <Input
                    id="priorNightSetupBudget"
                    placeholder="Prior Night setup Budget"
                    value={formData.priorNightSetupBudget}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        priorNightSetupBudget: Number(e.target.value),
                      })
                    }
                    className={cn(
                      errors.priorNightSetupBudget && "border-destructive",
                    )}
                  />
                  {errors.priorNightSetupBudget && (
                    <p className="text-sm text-destructive">
                      {errors.priorNightSetupBudget}
                    </p>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 order-7">
            <Button
              variant="outline"
              type="reset"
              onClick={() => handleReset()}
              className="bg-transparent"
            >
              Reset
            </Button>

            <Button
              variant="outline"
              type="submit"
              onClick={(e) => handleSubmit(e)}
              className="bg-transparent"
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}
